export default __webpack_public_path__ + "static/media/cool_2.2f022f7d.jpg";